import { render, staticRenderFns } from "./holidayActFemaleMain.vue?vue&type=template&id=031a72c3&scoped=true"
import script from "./holidayActFemaleMain.vue?vue&type=script&lang=js"
export * from "./holidayActFemaleMain.vue?vue&type=script&lang=js"
import style0 from "./holidayActFemaleMain.vue?vue&type=style&index=0&id=031a72c3&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a72c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031a72c3')) {
      api.createRecord('031a72c3', component.options)
    } else {
      api.reload('031a72c3', component.options)
    }
    module.hot.accept("./holidayActFemaleMain.vue?vue&type=template&id=031a72c3&scoped=true", function () {
      api.rerender('031a72c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P5_Activitys/NewYearsDay/holidayActFemaleMain.vue"
export default component.exports